import {ApiClient as Api} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {KpiValueEventDto, SlaTrackingQueryKey} from '../../types'

type Params = {
  plantUpmId: string
  kpiValueId: string
}

export const useSlaKpiTabValueEvents = (
  {plantUpmId, kpiValueId}: Params,
  options?: Omit<UseQueryOptions<KpiValueEventDto[], AxiosError>, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: [SlaTrackingQueryKey.SlaKpiTabValueEvents, plantUpmId, kpiValueId],
    queryFn: async () => {
      const path = `/sla-kpi-tracking/api/${plantUpmId}/sla-kpi/tab-values/${kpiValueId}/events`
      const response = await Api.axiosInstance.get<KpiValueEventDto[]>(path)
      return response.data
    },
    ...options
  })
}
